import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface RxChangeAlerts {
  isLoading: boolean;
  error: boolean;
  message?: string | null;
  RxChangeAlertsData?: any;
  Items?: any;
  Pagination?: any;
}

const initialState: RxChangeAlerts = {
  isLoading: false,
  error: false,
  message: null,
  RxChangeAlertsData: [],
  Items: [],
  Pagination: [],
};

const RxChangeAlertsSlice = createSlice({
  name: "RxChangeAlerts",
  initialState,
  reducers: {
    loadingRxChangeAlerts: (
      state: RxChangeAlerts,
      action: PayloadAction<{}>
    ) => {
      state.isLoading = true;
    },
    setRxChangeAlerts: (state: any, action: PayloadAction<RxChangeAlerts>) => {
      return action.payload;
    },
  },
});

export const { loadingRxChangeAlerts, setRxChangeAlerts } =
  RxChangeAlertsSlice.actions;
export default RxChangeAlertsSlice.reducer;
